import type { IFrameSignalReason } from '@proposify/ui';
import { trackError } from '@proposify/frontend-observability';
import { useSessionStorage } from 'hooks/useSessionStorage';
import type { EmbedSubtype } from './embed';

const STORAGE_KEY_PREFIX = 'embed-failure-reported';

export const useHandleEmbedFailure = (blockId: string, subtype: EmbedSubtype) => {
  const [getReportedReasons, setReportedReasons] = useSessionStorage<IFrameSignalReason[]>(`${STORAGE_KEY_PREFIX}:${blockId}`, []);

  return (reason: IFrameSignalReason, origin: string | null) => {
    const reportedReasons = getReportedReasons() ?? [];
    if (reportedReasons.includes(reason)) return;
    setReportedReasons([...reportedReasons, reason]);

    trackError(new Error(`Embed iframe failed to load: ${reason}`), {
      tags: { module: 'EmbedIframe' },
      extra: { blockId, subtype, failureReason: reason, origin },
    });
  };
};
